import React from 'react';
import LocationTemplate from './LocationTemplate';

const BurgawPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Burgaw"
      stateName="North Carolina"
      countyName="Pender"
      zipCodes={["28425"]}
      latitude={34.5515}
      longitude={-77.9253}
      population={4037}
      historicalFact="County seat of Pender County, incorporated in 1879; name derives from 'Burg Haw' meaning 'town on the hill.'"
      nearbyTowns={[
        "Wallace, NC",
        "Atkinson, NC",
        "Rocky Point, NC",
        "Maple Hill, NC",
        "Wilmington, NC",
        "Castle Hayne, NC",
        "Teachey, NC",
        "Rose Hill, NC"
      ]}
    />
  );
};

export default BurgawPage;